import { TRouteComponent } from './_shared/routes.types';
import { PageLoader } from '@photosi/rn-components/page-loader/PageLoader';
import { lazy, Suspense } from 'react';

const GoogleLoginApp = lazy(() => import('src/screen/google-login/GoogleLoginApp'));

export const GoogleLoginRoute: TRouteComponent = ({ route }) => {
  return (
    <Suspense fallback={<PageLoader />}>
      <GoogleLoginApp route={route} />
    </Suspense>
  );
};
